import * as fromContacts from "./contacts.reducer";
import { IState } from "../reducers";
import { IContactsResponse } from "../../common/services/contracts/contacts.contracts";

export const getEntireContacts = (wbsId: string) => (store: IState): fromContacts.IContactsState => store.contactsResponse[wbsId] ? store.contactsResponse[wbsId] : fromContacts.initialState;
export const getContacts = (wbsId: string) => (store: IState): IContactsResponse => getEntireContacts(wbsId)(store).contactsResponse;
export const getContactsLoading = (wbsId: string) => (store: IState): boolean => getEntireContacts(wbsId)(store).loading;
export const getContactsLoaded = (wbsId: string) => (store: IState): boolean => getEntireContacts(wbsId)(store).loaded;
export const getContactsError = (wbsId: string) => (store: IState): string => getEntireContacts(wbsId)(store).error;
